import { Auth } from "domain/model/Auth"
import { ProgressMeet, ProgressMeetFeedback, ProgressMeetFeedbackExternal } from "domain/model/ProgressMeet"
import ProgressMeetRepository from "domain/repository/Student/ProgressMeet"

export interface SaveProgressMeetFeedbackExternalUseCase {
  invoke(feedback: ProgressMeetFeedbackExternal): Promise<any>
}

export class SaveProgressMeetFeedbackExternal implements SaveProgressMeetFeedbackExternalUseCase {
  private repository: ProgressMeetRepository

  constructor(repository: ProgressMeetRepository) {
    this.repository = repository
  }

  async invoke(feedback: ProgressMeetFeedbackExternal): Promise<any> {
    try {
      return await this.repository.saveProgressMeetFeedbackExternal(feedback)
    } catch (error) {
      console.error("Error saving progress meet feedback:", error)
    }
  }
}
